import React, { useContext } from 'react';
import landingPageImg from '../../../assets/purchase-yearbooks-landing-page.jpg';
import Image from '../../Image';
import YearbookForm from '../_landing/Yearbooks/YearbookForm';
import { useStudent, useYearbookPackage } from '../_landing/Yearbooks';
import { CustomerContext } from '../../../contexts/CustomerContext';

export default function Yearbooks({ afterAdd = () => {} }) {
  const { customer } = useContext(CustomerContext);
  const { student } = useStudent({ schoolId: customer.currentSchool.id, studentId: customer.currentStudent.studentId });
  const { yearbook, yearbooks } = useYearbookPackage(customer.currentSchool.id);

  if (!student) return null;
  if (!yearbook) return null;

  return (
    <>
      <Image src={landingPageImg} alt="Purchase Yearbooks Image" />
      <YearbookForm
        student={student}
        school={customer.currentSchool}
        defaultYearbook={yearbook}
        yearbooks={yearbooks}
        pushToNextRoute={false}
        afterAdd={afterAdd}
        buttonText="Add to Cart"
      />
    </>
  );
}
